var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":_vm.color,"outlined":_vm.outlined,"block":_vm.block,"depressed":_vm.depressed,"loading":_vm.loading,"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.emitClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }